'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.syncRestaurantWithBusinessInfo = syncRestaurantWithBusinessInfo;
function syncRestaurantWithBusinessInfo(_ref) {
    var metasiteId = _ref.metasiteId,
        _ref$source = _ref.source,
        source = _ref$source === undefined ? '' : _ref$source,
        fetch = _ref.fetch;

    return fetch('https://sync.wixrestaurants.com/v1/meta_sites/' + metasiteId + '/site_properties/sync', {
        method: 'POST',
        headers: {
            source: source
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/restaurantsSyncService.js
// module id = 1002
// module chunks = 0